import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { User, UserService } from '@fry/lib/users';
import { FormData } from '@fry/lib/forms';
import { CanComponentDeactivate } from '@fry/components/common/form';

import { UserEditBasicForm } from './user-edit-basic.form';
import { NotifyService } from '@fry/lib/utils';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-user-edit-basic',
    templateUrl: './user-edit-basic.component.html',
    providers: [UserEditBasicForm],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserEditBasicComponent implements OnInit, CanComponentDeactivate {
  public user: User;
  public formData$: Observable<FormData>;

  constructor(
    private userService: UserService,
    private basicForm: UserEditBasicForm,
    private notify: NotifyService
  ) {}

  ngOnInit() {
    this.user = this.userService.user;
    this.formData$ = this.basicForm.init(this.user);
  }

  onSubmit() {
    this.basicForm.submit(this.user).subscribe(
      (user) => {
        this.userService.setUser(user);
        this.user = this.userService.user;
        this.notify.success($localize `Profile successfully saved`);
      },
      error => {
        this.notify.error(error);
      }
    );
  }

  canSafelyDeactivate() {
    return this.basicForm.pristine;
  }
}
